"use strict";
/*
    wordNum指令：
    html:<trs-word-num num-obj=""></trs-word-num>，
    css:处于oneImage.css样式表中，
    js:完成字数组件的页面替代与逻辑处理，调用参数为页面对象的标题或摘要属性，如：item.title
 */
angular.module('util.trsWordNum', [])
    .directive('trsWordNum', function() {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                oneImageWordNum: "@numObj",
                rule: "@" //校验规则写死在指令中
            },
            controller: function($scope, $element) {
                $scope.$watch('oneImageWordNum', function() {
                    var len = 0;
                    if (angular.isUndefined($scope.rule) || $scope.rule === "1") {
                        //去除首尾空格
                        // $scope.oneImageWordNum = $scope.oneImageWordNum.replace(/(^\s*)|(\s*$)/g, "");
                        //去除空格
                        // $scope.oneImageWordNum = $scope.oneImageWordNum.replace(/\s+/g, "");
                        len = $scope.oneImageWordNum.length;
                    } else if ($scope.rule === "2") {
                        //去除html标签
                        $scope.oneImageWordNum = $scope.oneImageWordNum.replace(/\<\/?[A-Za-z]+(.*?)\>/g, "");
                        for (var i = 0; i < $scope.oneImageWordNum.length; i++) {
                            var data = $scope.oneImageWordNum[i];
                            if (data.match(/[\u0000-\u00ff]/g)) len += 0.5;
                            else if (data.match(/[\u4e00-\u9fa5]|[！￥……（）——【】：“”‘’？《》？、·。，]/g)) len++;
                            else if (data.match(/[\uff00-\uffff]/g)) len++;
                            else if (data.match(/ /g)) len += 0.5;
                            else if (data.match(/　/g)) len++;
                        }
                    }
                    $scope.oneImageWordNumTrue = len;
                });

            },
            template: '<div style="width:25px" ng-bind="oneImageWordNumTrue" class="wordNum"></div>',

        };
    });
